export const convertCurrency = (
    convertType: 'integer' | '',
    value: number,
): number => {
    if (convertType === 'integer') {
        return value * 100;
    }
    return value / 100;
};
